// extracted by mini-css-extract-plugin
export var activityContainer = "_lt-0";
export var typingIndicatorContainer = "_lt-1";
export var typingIndicatorDot = "_lt-2";
export var wave = "_lt-3";